import { useAuthStore } from "@/stores/auth.store";
import { roleForProject, useProjectStore } from "@/stores/project.store";
import type { MembershipRole, Project } from "@/api/types";

interface CurrentProjectInfo {
  project: Project | null;
  /** Full role record for the current project, or null if the user has no
   *  membership (superadmins still get null here — use `isSuperadmin`). */
  role: MembershipRole | null;
  /** Convenience: the role's display name, or "Superadmin" / null. */
  roleName: string | null;
  isSuperadmin: boolean;
}

export function useCurrentProject(): CurrentProjectInfo {
  const project = useProjectStore((s) => s.currentProject);
  const user = useAuthStore((s) => s.user);
  const role = roleForProject(user, project);
  const isSuperadmin = !!user?.is_superadmin;

  return {
    project,
    role,
    roleName: role?.name ?? (isSuperadmin ? "Superadmin" : null),
    isSuperadmin,
  };
}
